<template>
  <div class="user-evaluation">
    <div class="rate_wrap">
      <span>评星</span>
      <van-rate v-model="startVal"  color="#ff5c00" size="0.4rem" void-color="#cccccc" />
    </div>
    <div class="rate_tag">
      <div class="tag_head">
        <span>标签</span>
        <p @click="tagShow=true">更多标签<i class="iconfont icon-xiala"></i></p>
      </div>
      <div class="tag_con max_hei">
        <van-checkbox-group v-model="tagCheck" max="5">
          <van-checkbox v-for="(item,index) in tagList" :key="index" class="tag_item" :name="item.name">
            {{item.name}}
            <div class="cancel"><i class="iconfont icon-guanbi2"></i></div>
          </van-checkbox>
        </van-checkbox-group>
      </div>
    </div>
    <div class="rate_text">
      <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请输入评价内容"
          show-word-limit
        />
    </div>
    <div class="rate_submit">
      <van-button color="#1890ff" @click="submit" round block>提交</van-button>
    </div>
    <div class="tag_popup" :class="{popup_show:tagShow}">
      <div class="popup_mask" v-if="tagShow" @click="tagShow=false"></div>
    </div>
    <div class="tag_con tag_con_pop" :class="{con_show:tagShow}">
      <van-checkbox-group v-model="tagCheck" max="5">
        <van-checkbox v-for="(item,index) in tagList" :key="index" class="tag_item" :name="item.name">
          {{item.name}}
          <div class="cancel"><i class="iconfont icon-guanbi2"></i></div>
        </van-checkbox>
      </van-checkbox-group>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import gql from 'graphql-tag'
export default {
  name: "user-evaluation",
  components:{
  },
  data() {
    return {
      startVal:0,
      tagShow:false,
      message:'',
      tagList:[
      ],
      tagCheck:[],
    } 
  },
  created(){
    this.getTagList();
  },
  mounted(){

  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:'getExhibitionId'
    }),
    exhibitorId(){
      return this.$route.query.exhibitorId;
    },
    productId(){
      return this.$route.query.productId;
    },
    isEx(){
      return this.$route.query.isEx=='true'?true:false;
    }
  },
  methods:{
    ...mapActions({ 
      userExEvaluate:'company/userExEvaluate',
      ProductEvaluate:'company/ProductEvaluate'
    }),
    getTagList(){
      // console.log(this.exhibitionId);
      // console.log(this.isEx,'ooooooooooooooooooooooooooooo')
      let query=gql`
        query queryEvaluateTag($where:String!,$order:String ){
          queryEvaluateTag(query:{page:1,size:200,where:$where,order:$order}){
            items {	
              id
              name
            }
          }
        }`
      let where={
        "Equal":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        },
        "Equal1":{
          "n":"tagType",
          "v":this.isEx?0:1
        },
        "Equal_isdeleted": {
          "n": "isDeleted",
          "v": 0
        }
      }
      let order=[
        {
          "N":"showIndex",
          "v":1
        },
        {
          "N":"createAt",
          "v":0
        }
      ]
      this.$apollo.addSmartQuery("queryEvaluateTag",{ 
        query:query,
        variables:{
          where:JSON.stringify(where),
          order:JSON.stringify(order)
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          console.log(data);
          let res=data.data.queryEvaluateTag;
          this.tagList=res.items
        },
        error(err){
          this.Loading=false;
          console.log('err',err)
        }
      })
    },
    async submit(){
      if(this.startVal<1){
        this.$toast.fail('请选择星级');
        return
      }
      if(!this.message){
        this.$toast.fail('内容不能为空');
        return
      }
      // console.log(this.tagCheck.join(';'),this.userInfo);

      if (!this.isEx){
        console.log('展品评价')
        this.proSubmit()
      }
      else {
        console.log('展商评价')
        this.exSubmit()
      }
    },
    async exSubmit(){
      let opt={
        exhibitionId:this.exhibitionId,
        exhibitorId:this.exhibitorId,
        score:this.startVal,
        content:this.message,
        tags:this.tagCheck.join(';'),
        isShow:true,
        memberId:this.userInfo.id,
        name:this.userInfo.name||this.userInfo.nickName,
        jobTitle:this.userInfo.jobTitle||'',
        avatarUrl:this.userInfo.avatarUrl
      };
      let res= await this.userExEvaluate(opt);
      if(res.result){
        this.$toast.success('提交成功');
        this.$router.back();
      }else{
        this.$toast.fail('提交失败')
      }
    },
    async proSubmit(){
      let opt={
        exhibitionId:this.exhibitionId,
        exhibitorId:this.exhibitorId,
        productId:this.productId,
        score:this.startVal,
        content:this.message,
        tags:this.tagCheck.join(';'),
        isShow:true,
        memberId:this.userInfo.id,
        name:this.userInfo.name||this.userInfo.nickName,
        jobTitle:this.userInfo.jobTitle||'',
        avatarUrl:this.userInfo.avatarUrl
      };
      let res= await this.ProductEvaluate(opt);
      if(res.result){
        this.$toast.success('提交成功');
        this.$router.back();
      }else{
        this.$toast.fail('提交失败')
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.user-evaluation{
  background: #f2f2f2;
  padding: 0.3rem 0.3rem 0;
  height: 100vh;
  .rate_wrap{
    height: 0.88rem;
    background: #fff;
    width: 100%;
    border-radius: 0.05rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.2rem;
    >span{
      font-size: 0.26rem;
      color: #333;
      font-weight: bold;
    }
  }
  .rate_tag{
    margin-top: 0.2rem;
    padding: 0.3rem 0.2rem;
    background: #fff;
    .tag_head{
      display: flex;
      justify-content: space-between;
      >span{
        font-size: 0.26rem;
        color: #333;
        font-weight: bold;
      }
      >p{
        font-size: 0.26rem;
        color: #666;
        .iconfont{
          font-size: 0.32rem;
          display: inline-block;
          transform: rotate(-90deg) scale(1.2);
        }
      }
    }
  }
  .tag_con{
    margin-top: 0.1rem;
    &.max_hei{
      ::v-deep .van-checkbox-group{
        max-height: 1.68rem;
        overflow: hidden;
      }
    }
    ::v-deep .van-checkbox-group{
      display: flex;
      flex-wrap: wrap;
      .tag_item{
        display: block;
        height: 0.64rem;
        padding:0 0.24rem;
        line-height: 0.64rem;
        margin: 0.2rem 0.16rem 0 0;
        border-radius: 0.05rem;
        background: #f2f2f2;
        justify-content: center;
        position: relative;
        &[aria-checked=true]{
          background: #ffeee5;
          .van-checkbox__label{
            color: #ff5c00;
          }
          .cancel{
            display: flex;
          }
        }
        .cancel{
          display: none;
          justify-content: center;
          align-items: center;
          border-radius: 0.22rem 0 0 0  ;
          width: 0.24rem;
          height: 0.24rem;
          background:#ff5c00;
          position: absolute;
          bottom: 0;
          right: 0;
          .iconfont{
            color: #fff;
            font-size: 0.16rem;
            line-height: 1;
            transform: translate(1px,1px);
          }
        }
        .van-checkbox__icon--round{
          display: none;
          position: absolute;
          top: 0;
          left: 0;
        }
        .van-checkbox__label{
          margin-left: 0;
          color: #666;
        }
      }
    }
  }
  .rate_text{
    margin-top: 0.2rem;
    .van-field{
      padding: 0.2rem ;
      ::v-deep .van-field__word-limit{
        color: #999;
      }
    }
  }
  .rate_submit{
    position: fixed;
    padding: 0.1rem 0.5rem;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    width: 100%;
    height: 0.93rem;
    z-index: 98;
    border-top: 1px solid #e6e6e6;
    .van-button{
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: inherit;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  .tag_con_pop{
    transition: all 0.3s;
    padding:0 0.3rem 0.3rem;
    width: 80%;
    height: 100%;
    margin-top: 0;
    position: fixed;
    z-index: 100;
    right: -100%;
    top: 0;
    background: #fff;
    overflow: auto;
    &.con_show{
      right: 0;
    }
  }
  .tag_popup{
   width:100vw;
   height: 100vh;
   position: fixed;
   left: 0;
   top: 0;
   z-index: -1;
   background: rgba($color: #000, $alpha: 0);
   transition: background 0.6s;
   &.popup_show{
     z-index: 99;
     background: rgba($color: #000, $alpha: 0.4);
   }
   .popup_mask{
    opacity: 0;
    width: 20%;
    left: 0;
    position: absolute;
    height: 100%;
   }
   
  }
}
</style>
